import { FileInput } from '@mantine/core';
import { useRef, useState, useEffect } from 'react';
import MantineImage from './image';
import upload from '../../assets/images/upload.svg';

const MantineFileInput = (props: any) => {
  const { label, placeholder, multiple, value, onChange, error, classNames, style, withAsterisk, page, fileUrl, onRemoveFile } = props;
  const fileInputRef = useRef<any>(null);

  // State for handling multiple files (only for the drawing page)
  const [files, setFiles] = useState<File[]>(value || []);

  const handleRightSectionClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  useEffect(() => {
    if (!value || value.length === 0) {
      setFiles([]);
    }
  }, [value]);

  const handleFileChange = (newFiles: File | File[] | null) => {
    if (!newFiles) return;
    if (multiple && page === 'drawing') {
      const updatedFiles = Array.isArray(newFiles) ? [...files, ...newFiles] : [...files, newFiles];
      setFiles(updatedFiles);
      onChange?.(updatedFiles);
    } else {
      setFiles([newFiles as File]);
      onChange?.(newFiles);
    }
  };
  const handleRemoveFile = (index: number) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    onChange?.(updatedFiles);
  };

  const RightSection = () => (
    <button
      type='button'
      className='h-[40px] text-sm w-[102px] text-center flex items-center justify-center text-white'
      onClick={handleRightSectionClick}
      style={{ background: '#2F7FE2', borderRadius: '40px' }}
    >
      <MantineImage src={upload} className='w-5 mr-2' />
      Browse
    </button>
  );

  const RemoveButton = () => (
    <button
      type="button"
      onClick={onRemoveFile}
      className="ml-4 text-red-500 text-lg font-bold"
    >
      X
    </button>
  );

  return (
    <div className="relative">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label} {withAsterisk && <span style={{ color: 'red' }}>*</span>}
        </label>
      )}
      {fileUrl ? (
        <div className="flex items-center border border-gray-400 rounded-full px-2 py-1.5">
          <a
            href={fileUrl}
            className="text-black text-sm flex items-center truncate w-[200px] h-[20px] mr-3"
            target="_blank"
            rel="noopener noreferrer"
          >
            {fileUrl}
          </a>
          <RemoveButton />
        </div>
      ) : (
        <FileInput
          placeholder={placeholder}
          multiple={multiple}
          classNames={classNames}
          rightSection={<RightSection />}
          withAsterisk={withAsterisk}
          value={files}
          onChange={handleFileChange}
          error={error}
          style={style}
          ref={fileInputRef}
          rightSectionWidth={100}
        />
      )}

      {multiple && page === 'drawing' && files.length > 0 && (
        <div className="absolute top-[90%] left-[40%] ml-3 mt-4 bg-white z-10 w-56 border border-gray-300 shadow-lg rounded-md p-2 max-h-32 overflow-y-auto">
          {files.map((file, index) => (
            <div key={index} className="flex items-center justify-between px-2 py-1">
              <a
                href={URL.createObjectURL(file)}
                className="text-black text-sm truncate w-[150px]"
                target="_blank"
                rel="noopener noreferrer"
              >
                {file.name}
              </a>
              <button
                type="button"
                onClick={() => handleRemoveFile(index)}
                className="ml-2 text-red-500 text-lg font-bold"
              >
                X
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default MantineFileInput;